import BaseMystery from '../BaseMystery'

const SeventhSorrow = () => {
	const imagesList = [
		//"https://www.meisterdrucke.ie/kunstwerke/1260px/Unbekannt_-_Our_Lady_of_Fatima_church_Way_of_the_cross_Station_14_Jesus_is_placed_in_the_tom_-_%28MeisterDrucke-1042582%29.jpg",
		"https://www.meisterdrucke.ie/kunstwerke/1260px/Unbekannt_-_Entombment_of_Christ_-_%28MeisterDrucke-692391%29.jpg",
	];

	const titleText = "The Body of Jesus is entombed";
	const scriptureQuote = "Now in the place where he had been crucified there was a garden, and in the garden a new tomb, in which no one had yet been buried. So they laid Jesus there because of the Jewish preparation day; for the tomb was close by.";
	const scriptureCitation = "John 19:41-42 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=John%2019%3A38-42&version=NABRE";

	return (
		<BaseMystery titleText={titleText}
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={false} />
	);
};

export default SeventhSorrow;